<template>
  <div class="emoji-warp">
    <div class="emojis">
      <span class="emoji" v-for="(emoji, index) in emojis" :key="index" @click="handleClick(emoji)">{{ emoji }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Emoji',
  components: {
  },
  computed: {
  },
  data () {
    return {
      emojis: [
        '😄',
        '😁',
        '😅',
        '😂',
        '🤣',
        '🫠',
        '😊',
        '😇',
        '🤪',
        '😜',
        '🫣',
        '🤫',
        '🤔',
        '🫡',
        '🤨',
        '😶',
        '😮‍💨',
        '😐',
        '🤥',
        '😌',
        '😔',
        '😪',
        '😴',
        '🤮',
        '🤧',
        '🥶',
        '😵‍💫',
        '😎',
        '😕',
        '😟',
        '🙁',
        '😳',
        '🥺',
        '😓',
        '😡',
        '👌',
        '🫰',
        '✌',
        '👍',
        '👎',
        '👏',
        '🤝',
        '🫶',
        '🙏',
        '🌹',
        '🌸',
        '🚀',
        '⛅',
        '🌧',
        '🏅',
        '🏆',
        '🇨🇳'
      ]
    }
  },
  methods: {
    handleClick (emoji) {
      this.$emit('select-emoji', emoji)
    }
  }
}
</script>

<style lang="stylus" scoped>
.emojis {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.emoji {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/Emoji.vue